export const SET_NEWS_DIGESTS_SUGGESTION_DATA = 'SET_NEWS_DIGESTS_SUGGESTION_DATA';
export const CLEAN_NEWS_DIGESTS_SUGGESTION_DATA = 'CLEAN_NEWS_DIGESTS_SUGGESTION_DATA';



// WEBPACK FOOTER //
// ./src/redux_related/newsDigestsSuggestions/actions.js